import { render, staticRenderFns } from "./DeactivateAccountModal.vue?vue&type=template&id=3381f0cb&scoped=true"
import script from "./DeactivateAccountModal.vue?vue&type=script&lang=ts"
export * from "./DeactivateAccountModal.vue?vue&type=script&lang=ts"
import style0 from "./DeactivateAccountModal.vue?vue&type=style&index=0&id=3381f0cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381f0cb",
  null
  
)

export default component.exports